export default __webpack_public_path__ + "static/media/Earth.31a36edf.svg";